module.exports = __webpack_public_path__ + "img/huifu@3x.89b6fca0.svg";